import { ProjectType } from "../../../common/constants";
import api from "../../../components/api";
import { Proposal } from "../../jobs/Proposals/proposalsModel";

export type ProposalDetailedCloseData = {
  projectId: number;
  proposalId: number;
  timestamp: string;
  approveDateUtc: string;
  daysToClose: number;
  divisionName: string;
  salesPersonEmail: string;
  salesPersonName: string;
  jobType: ProjectType;
}

export type ProposalDetailedTurnaroundData = {
  projectId: number;
  proposalId: number;
  initiateDateUtc: string;
  timestamp: string;
  proposalTurnaround: number;
  divisionName: string;
  salesPersonEmail: string;
  salesPersonName: string;
  jobType: ProjectType;
}

export type ProposalReport = {
  groupedProposalsData: ProposalsSummary,
  detailedDaysToCloseData: ProposalDetailedCloseData[],
  detailedTurnaroundData: ProposalDetailedTurnaroundData[]
}

export type ProposalTurnaroundData = {
  totalProposalTurnaroundDays: number
  proposalTotal: number
  proposalTurnaround: number
}

export type DaysToCloseData = {
  totalDaysToClose: number
  proposalTotal: number
  daysToClose: number

}

export type ProposalsSummary = {
  [key: string]: any;
  approved: ProposalReportData[],
  sent: ProposalReportData[],
  lost: ProposalReportData[],
  unsent: ProposalReportData[],
  pending: ProposalReportData[]
}

export type ProposalReportData = {
  projectId: number,
  jobName: string,
  jobType: ProjectType,
  jobTypeName?: string,
  price: number,
  customerId: number,
  displayName: string,
  propertyId: number,
  address1: string,
  city: string,
  state: string,
  zip: number,
  salesPersonName: string,
  property?: string,
  isSold: boolean,
  divisions: string
};

export const getProposalsReportData = async (startDate?: string, endDate?: string): Promise<ProposalReport> => {
  return (await api.get(`/web/datacenter/proposals/${startDate}/${endDate}`)).data
}

export type ProposalDto = Pick<Proposal, 'id' | 'initiateDateUtc' | 'initiatedByEmail' | 'initiatedBy' | 'isApproved' | 'approveDateUtc' >

export const getJobProposals = async (jobId: number): Promise<ProposalDto[]> => {
  return (await api.get(`/web/datacenter/proposals-events/${jobId}`)).data
}